var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-no-auth"},[_c('blank-section',{attrs:{"empty-info":"没有访问权限"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }